import {Component, OnInit,} from '@angular/core';
import { IValueChange } from '../../../core/interfaces/form-value-change.interface';
import { ProfileFormTemplateProviders } from '../../../core/templates/profile-form.template.providers';
import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {
  BFBeforeProfileCreate,
  BFOnValueChange, BFProfileOnSave,
} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {ChildParties} from "../../models/child-parties.model";

@Component({
  selector: 'app-child-parties',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class ChildPartiesComponent extends AbstractProfileFormComponent implements OnInit,
  BFOnValueChange,BFBeforeProfileCreate, BFProfileOnSave {

  fgppBeforeCreate(){
   this.formMgr.get(ChildParties.CHILD_IDENTIFIER_TYPE).setValue('COMPANY_ID');
   this.formMgr.get(ChildParties.CHILD_BK_TYPE).setValue('USABA');
  }

  fgppOnSave(): boolean {
    this.setNullToEmptyChildPartyCode()
    return true;
  }

  setNullToEmptyChildPartyCode(){
    let value = this.formMgr.get(ChildParties.CHILD_CUST_CODE).getValue();
    if(!value){
      let childIdVal = this.formMgr.get(ChildParties.CHILD_ID).getValue();
      let childBankIdVal = this.formMgr.get(ChildParties.CHILD_BK_ID).getValue();
      if (childIdVal && childBankIdVal) {
        this.formMgr.get(ChildParties.CHILD_CUST_CODE).setValue(childIdVal+'^^'+childBankIdVal);
      }
    }
  }

  fgppValueChanges(change: IValueChange): void {
    switch (change.control) {
      case ChildParties.PARENT_CUST_CODE:
        this.updateParentCustName();
        break;
      case ChildParties.CHILD_CUST_CODE:
        this.updateChildCustName();
        break;
      case ChildParties.CHILD_IDENTIFIER_TYPE:
        this.handleChildIdControl();
        break;
      case ChildParties.CHILD_BK_TYPE:
        this.handleChildBankIdControl();
        break;
    }
  }

  private updateParentCustName(): void {
    const data = this.getDrilldownData(ChildParties.PARENT_CUST_CODE);
    const name = data ? data['CUSTOMRS.CUST_NAME'] : '';
    this.formMgr.get(ChildParties.PARENT_CUST_NAME).setValue(name);
  }

  private updateChildCustName(): void {
    const data = this.getDrilldownData(ChildParties.CHILD_CUST_CODE);
    const name = data ? data['CUSTOMRS.CUST_NAME'] : '';
    this.formMgr.get(ChildParties.CHILD_CUST_NAME).setValue(name);
  }

  private handleChildIdControl(): void {
    let value =  this.formMgr.get(ChildParties.CHILD_IDENTIFIER_TYPE).getValue();
    let childIdControl= this.formMgr.get(ChildParties.CHILD_ID);
    childIdControl.setValue('');
    if(value==''){
      childIdControl.disable();
    }else{
      childIdControl.enable();
    }
  }

  private handleChildBankIdControl():void{
    let value =  this.formMgr.get(ChildParties.CHILD_BK_TYPE).getValue();
    let childBankIdControl= this.formMgr.get(ChildParties.CHILD_BK_ID);
    childBankIdControl.setValue('');
    if(value==''){
      childBankIdControl.disable();
    }else{
      childBankIdControl.enable();
    }
  }

}
